import { useEffect, useState, useCallback } from "react";
import Pagination from "components/Pagination";
// Import your existing API endpoints
import { getScannerLoginLogs, getScanLogs } from "api/scanner.api";

export default function LogsTable({
  companyId,
  scannerId,
  type = "login", // "login" | "scan"
}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [pagination, setPagination] = useState({
    total: 0,
    totalPages: 1,
  });

  const fetchLogs = useCallback(async () => {
    if (!companyId) return;

    setLoading(true);
    try {
      const payload = {
        company_id: companyId,
        scanner_id: scannerId,
        page,
        limit,
      };

      // Call API dynamically based on `type` prop
      const res =
        type === "scan"
          ? await getScanLogs(payload)
          : await getScannerLoginLogs(payload);

      const responseData =  res.data || {};
      const logsList = responseData.data.logs || [];
      console.log("logsList",logsList)

      setData(logsList);
      setPagination({
        total: responseData.data.pagination?.total || logsList.length,
        totalPages: responseData.data.pagination?.totalPages || 1,
      });
    } catch (error) {
      console.error(`Failed to fetch ${type} logs:`, error);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [companyId, scannerId, type, page, limit]);

  useEffect(() => {
    fetchLogs();
  }, [fetchLogs]);

  // Helper date formatter
  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const d = new Date(dateStr);
    return d.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  return (
    <div className="table-card overflow-hidden">
      <div className="table-scroll-body">
        <table className="custom-table">
          <thead className="custom-table-header ">
            {type === "login" ? (
              <tr>
                <th className="w-16 text-center">S.no</th>
                <th>Date & Time</th>
                <th >Login Code</th>
              </tr>
            ) : (
              <tr>
                <th className="w-16 text-center">S.no</th>
                <th>DATE & TIME</th>
                <th>VISITOR NAME</th>
                <th>EVENT DAY</th>
                <th className="text-center">STATUS</th>
              </tr>
            )}
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan={type === "login" ? 3 : 5}
                  className="custom-table-cell py-8 text-center text-sm text-gray-500"
                >
                  Loading {type} logs...
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td
                  colSpan={type === "login" ? 3 : 5}
                  className="custom-table-cell py-8 text-center text-sm text-gray-500"
                >
                  No {type} logs found
                </td>
              </tr>
            ) : (
              data.map((item, index) => {
                const serialNo = (page - 1) * limit + index + 1;

                if (type === "login") {
                 

                  return (
                    <tr key={item._id || index} className="custom-table-row">
                      <td className="custom-table-cell text-center font-medium text-gray-500">
                        {serialNo}
                      </td>
                      <td className="custom-table-cell font-medium text-gray-800">
                        {formatDate(item.loggedInAt)}
                      </td>
                      <td className="custom-table-cell text-center">
                      
                          {item.loginCode}
                        
                      </td>
                    </tr>
                  );
                }

                // Render Scan Logs
                const visitorName = item.visitor
                  ? `${item.visitor.firstName || ""} ${item.visitor.lastName || ""}`.trim()
                  : "N/A";

                return (
                  <tr key={item._id || index} className="custom-table-row">
                    <td className="custom-table-cell text-center font-medium text-gray-500">
                      {serialNo}
                    </td>
                    <td className="custom-table-cell  ">
                      {formatDate(item.scannedAt)}
                    </td>
                    <td className="custom-table-cell ">
                      {visitorName}
                    </td>
                    <td className="custom-table-cell ">
                      {item.eventDay || "N/A"}
                    </td>
                    <td className="custom-table-cell text-center">
                      <span
                        className={`inline-block rounded-[8px] px-3 py-1 text-xs font-semibold ${
                          item.allowed
                            ? "bg-[#dcfce7] text-[#16a34a]"
                            : "bg-[#fee2e2] text-[#ef4444]"
                        }`}
                      >
                        {item.allowed ? "Allowed" : "Denied"}
                      </span>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Footer */}
      <Pagination
        currentPage={page}
        totalPages={pagination.totalPages}
        totalEntries={pagination.total}
        limit={limit}
        onPageChange={(newPage) => setPage(newPage)}
        onLimitChange={(newLimit) => setLimit(newLimit)}
      />
    </div>
  );
}